import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar';
import Error from '../../components/404/404'
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer';
import Logo from '../../images/logo.png'
const ErrorPage = () => {
    return (
        <Fragment>
            <Navbar hclass={'wpo-site-header wpo-site-header-s2'} Logo={Logo} />
            <Error />
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default ErrorPage;



